/* Search assists: non-destructive spelling & related model suggestions. Keeps app search authoritative. */
(()=>{'use strict';
const rules=[
[/^(?:gortex|goretex|gore tex)$/i,['Gore-Tex']],
[/^(?:vibran|vibram)$/i,['Vibram']],
[/^(?:bester|bestar|bestard)$/i,['Bestard']],
[/^(?:zamberlán|zamberlam|zamberlan)$/i,['Zamberlan']],
[/^(?:hispania|hispania boa)$/i,['Hispania BOA','Belmonte BOA']],
[/^(?:belmonte|belmonte boa)$/i,['Belmonte BOA','Hispania BOA']],
[/^(?:chiruca boa)$/i,['Chiruca BOA','Hispania BOA','Vermont BOA']],
[/^(?:vigo|pantalon vigo|pantalón vigo)$/i,['Pantalón Chiruca Vigo']],
[/^(?:botas sin cordones)$/i,['Botas BOA']],
[/^(?:zapatillas de estar en casa)$/i,['Zapatillas de casa']],
[/^(?:nauticos hombre|náuticos hombre)$/i,['Náuticos hombre']]
];
const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim().toLowerCase();
function suggest(input){const v=normalize(input.value);if(v.length<3)return[];const rule=rules.find(x=>x[0].test(v));return rule?rule[1].filter(s=>normalize(s)!==v).slice(0,3):[];}
function init(){
document.querySelectorAll('input[type="search"]').forEach(input=>{
if(input.dataset.lvcCroSearch)return;input.dataset.lvcCroSearch='1';
const form=input.closest('form');if(!form)return;
const hint=document.createElement('div');hint.className='lvc-cro-search-hints';hint.hidden=true;hint.setAttribute('aria-label','Búsquedas relacionadas');form.appendChild(hint);
const update=()=>{const arr=suggest(input);hint.replaceChildren();if(!arr.length){hint.hidden=true;return;}
const label=document.createElement('span');label.textContent='También puedes buscar: ';hint.appendChild(label);
arr.forEach(term=>{const link=document.createElement('a');link.href='/search?q='+encodeURIComponent(term)+'&options%5Bprefix%5D=last';link.textContent=term;hint.appendChild(link);});hint.hidden=false;};
input.addEventListener('input',update);input.addEventListener('focus',update);update();
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
const style=document.createElement('style');style.textContent='.lvc-cro-search-hints{padding:8px 10px;display:flex;align-items:center;flex-wrap:wrap;gap:6px;font-size:12px;color:#344055;background:#fff}.lvc-cro-search-hints[hidden]{display:none}.lvc-cro-search-hints a{color:#062156;text-decoration:underline;text-underline-offset:2px}';document.head.appendChild(style);
})();